<template>
  <a-row>
    <a-space class="m-8" v-if="editIs">
      <a-button v-hasPermi="['bom:bomRoutingLineCcWorkCenter:add']" class="m-r-8" type="primary" @click="onShowAdd">新增</a-button>
      <a-button v-hasPermi="['bom:bomRoutingLineCcWorkCenter:list']" class="m-r-8" @click="getTableList">刷新</a-button>
    </a-space>
    <ls-api-table
      ref="dataTable"
      :tableProps="tableProps"
      :columns="columns"
      :scroll="{ x: 400, fixScreen: true }"
      bordered
    >
      <template #edmitOperation="{ record, index }">
        <template v-if="editIs">
          <a-icon v-if="record.loading" type="loading" />
          <template v-if="!record.editIs && !record.loading">
            <ls-cancel v-hasPermi="['bom:bomRoutingLineCcWorkCenter:remove']" @confirm="onDeleteRow(record, index)" title="确定要删除吗?">
              <a-icon type="delete" title="删除" />
            </ls-cancel>
          </template>
        </template>
      </template>
    </ls-api-table>
    <WorkSelectModal
      ref="workSelectModalRef"
      :detailData="detailData"
      @successCall="getTableList"
    />
  </a-row>
</template>

<script>
import {
  apiGetRoutingLineCcWorkCenter,
  apiDeleteRoutingLineCcWorkCenter
} from '@/api/mes/basedata/standardProcessNew';
import { generateLsTableResData } from '@/utils/util'
import WorkSelectModal from './work-select-modal.vue';

export default {
  name: 'WorkTable',
  components: { WorkSelectModal },
  props: {
    editIs: {
      type: Boolean,
      default: true
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableProps: {
        requestApi: generateLsTableResData(apiGetRoutingLineCcWorkCenter)
      },
      columns: [
        {
          title: '加工组织',
          dataIndex: 'organizationName',
          align: 'center'
        },
        {
          title: '车间',
          dataIndex: 'workshopCode',
          align: 'center'
        },
        {
          title: '工作中心编码',
          dataIndex: 'workCenterCode',
          align: 'center'
        },
        {
          title: '工作中心名称',
          dataIndex: 'centerName',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'edmitOperation',
          scopedSlots: { customRender: 'edmitOperation' },
          align: 'center',
          width: 90
        }
      ]
    }
  },
  watch: {
    detailData: {
      handler() {
        this.$nextTick(() => {
          this.getTableList();
        })
      }
    }
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    getTableList(currentPage) {
      const { id: routingId } = this.detailData;
      if(routingId) {
        this.$refs.dataTable.searchParams = { routingId };
        this.$refs.dataTable.getData(!!currentPage);
      }
    },
    onShowAdd() {
      this.$refs.workSelectModalRef.show();
    },
    onDeleteRow(record, index) {
      this.$emit('delete', record, index);
      this.$set(record, 'loading', true)
      apiDeleteRoutingLineCcWorkCenter(record.id).then((res) => {
        if(res.code === 200) {
          this.$message.success('保存成功');
          this.getTableList();
        }
      }).finally(() => {
        record.loading = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}
.m-r-8 {
  margin-right: 8px;
}
.m-8 {
  margin: 8px 0;
}
.text-3-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
  height: 63.5px;
}
/deep/.ant-btn-link {
  padding: 0 4px;
}
.read-selection {
  /deep/.ant-select-selection {
    border: 0;
    user-select: text;
  }
  /deep/.ant-select-selection__rendered {
    margin-right: 0;
  }
  /deep/.ant-select-selection--single .ant-select-selection__rendered {
    margin-left: 0;
  }
  /deep/.ant-select-disabled .ant-select-selection {
    background: transparent;
    cursor: unset;
  }
  /deep/.ant-select-disabled {
    color: inherit;
  }
  /deep/.ant-select-arrow {
    display: none;
  }
  /deep/.ant-input-number-disabled {
    background: transparent;
    border: 0;
    color: inherit;
  }
}
</style>
